import * as React from 'react';
import { observer } from 'mobx-react';
import InfoBarViewState from '../schema/InfoBarViewState';
import InfoBarMessage from './InfoBarMessage';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

export interface InfoBarProps extends InfoBarViewState {
    className?: string;
    textContainerClassName?: string;
    colorScheme?: ColorScheme;
}

@observer
export default class InfoBar extends React.Component<InfoBarProps, any> {
    render() {
        // VSO 1777: add collapse/expand behavior to info bar
        // VSO 1778: sort info messages in info bar based on ranks
        return this.props.messages.length > 0 ? (
            <div className={this.props.className}>
                {this.props.messages.map(message => (
                    <InfoBarMessage
                        key={message.key}
                        textContainerClassName={this.props.textContainerClassName}
                        colorScheme={this.props.colorScheme}
                        {...message}
                    />
                ))}
            </div>
        ) : null;
    }
}
